export const SET_BANNERS_FOR_MAIN_PAGE = 'SET_BANNER_FOR_MAIN_PAGE';
export const SET_PROMO_BANNER_FOR_MAIN_PAGE = 'SET_PROMO_BANNER_FOR_MAIN_PAGE';
export const SET_PROMO_DOUBLE_BANNERS_FOR_MAIN_PAGE = 'SET_PROMO_DOUBLE_BANNERS_FOR_MAIN_PAGE';
